<template>
  <div class="app-container">
    <!-- 标语展示区 -->
    <div class="slogan-container">
      <transition-group name="slogan-fade">
        <div
            v-for="(slogan, index) in visibleSlogans"
            :key="slogan.id"
            class="slogan"
            :style="{
            top: slogan.position.top + 'px',
            left: slogan.position.left + 'px',
            fontSize: slogan.size + 'px',
            color: slogan.color,
            width: slogan.width + 'px'
          }"
        >
          {{ slogan.text }}
        </div>
      </transition-group>
    </div>

    <!-- 爱心动画 -->
    <div
        v-for="(heart, index) in hearts"
        :key="'heart'+index"
        class="heart"
        :style="heart.style"
    >
      ❤️
    </div>

    <!-- 页脚 -->
    <div class="footer">
      <p>何湘茹冲冲冲</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GratitudeSlogan',
  data() {
    return {
      slogans: [
        { id: 1,  text: "虽然放弃很容易，坚持一定很酷！", size: 24, color: "#ff6b6b" },
        { id: 2,  text: "来都来了，不比比怎么知道！", size: 22, color: "#ff8e8e" },
        { id: 3,  text: "绿道都拿下了，还有什么做不到的！" ,size: 26, color: "#ff5252" },
        { id: 4,  text: "坚持就一定可以的", size: 28, color: "#ff9e9e" },
        { id: 5,  text: "可以的，可以的，稳稳拿下", size: 28, color: "#ff3d3d" },
        { id: 6,  text: "勇敢小何，不怕困难",  size: 22, color: "#ff7b7b" },
        { id: 7,  text: "一切皆有机会",  size: 24, color: "#ff6b6b" },
        { id: 8,  text: "稳稳拿捏", size: 26,  color: "#ff8e8e" },
        { id: 9,  text: "越到最后越不能放弃", size: 22, color: "#ff5252" },
        { id: 10, text: "再努力一点",  size: 22, color: "#ff9e9e" },
        { id: 11, text: "拿下拿下！", size: 24, color: "#ff3d3d" },
        { id: 12, text: "小何冲冲冲！！！", size: 24, color: "#ff6b6b" }
      ],
      visibleSlogans: [],
      hearts: [],
      sloganInterval: null,
      heartInterval: null,
      containerSize: { width: 0, height: 0 }
    }
  },
  mounted() {
    this.updateContainerSize();
    window.addEventListener('resize', this.updateContainerSize);

    // 初始化显示标语
    this.showNextSlogans();

    // 设置标语轮换
    this.sloganInterval = setInterval(() => {
      this.showNextSlogans();
    }, 3000);

    // 初始爱心
    this.createHearts(10);

    // 定时添加爱心
    this.heartInterval = setInterval(() => {
      this.createHearts(1);
    }, 1500);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateContainerSize);
    clearInterval(this.sloganInterval);
    clearInterval(this.heartInterval);
  },
  methods: {
    updateContainerSize() {
      const container = document.querySelector('.slogan-container');
      if (container) {
        this.containerSize = {
          width: container.clientWidth,
          height: container.clientHeight
        };
      }
    },
    getTextWidth(text, fontSize) {
      // 创建一个临时元素测量文本宽度
      const span = document.createElement('span');
      span.style.visibility = 'hidden';
      span.style.position = 'absolute';
      span.style.fontSize = fontSize + 'px';
      span.style.fontFamily = 'Ma Shan Zheng, cursive';
      span.style.whiteSpace = 'nowrap';
      span.textContent = text;
      document.body.appendChild(span);
      const width = span.offsetWidth;
      document.body.removeChild(span);
      return width;
    },
    findNonOverlappingPosition(slogan, existingSlogans) {
      const maxAttempts = 100;
      const padding = 20; // 标语间最小间距
      const fontSize = slogan.size;

      // 计算文本宽度
      const textWidth = this.getTextWidth(slogan.text, fontSize);
      const textHeight = fontSize * 1.5; // 估算高度

      for (let attempt = 0; attempt < maxAttempts; attempt++) {
        // 随机位置
        const left = Math.random() * (this.containerSize.width - textWidth - padding);
        const top = Math.random() * (this.containerSize.height - textHeight - padding);

        // 检查是否与现有标语重叠
        let overlaps = false;
        for (const existing of existingSlogans) {
          const existingLeft = existing.position.left;
          const existingTop = existing.position.top;
          const existingRight = existingLeft + existing.width;
          const existingBottom = existingTop + existing.size * 1.5;

          const newRight = left + textWidth;
          const newBottom = top + textHeight;

          // 检查矩形是否重叠
          if (!(left > existingRight + padding ||
              newRight < existingLeft - padding ||
              top > existingBottom + padding ||
              newBottom < existingTop - padding)) {
            overlaps = true;
            break;
          }
        }

        if (!overlaps) {
          return {
            left: Math.max(padding, left),
            top: Math.max(padding, top),
            width: textWidth
          };
        }
      }

      // 如果找不到理想位置，返回一个默认位置
      return {
        left: padding,
        top: padding,
        width: textWidth
      };
    },
    showNextSlogans() {
      // 每次显示3-5条标语
      const count = Math.min(5, Math.floor(Math.random() * 3) + 3);
      this.visibleSlogans = [];

      // 随机选择标语
      const shuffled = [...this.slogans].sort(() => 0.5 - Math.random());

      for (let i = 0; i < count && i < shuffled.length; i++) {
        // 随机调整大小
        const baseSize = shuffled[i].size;
        const size = baseSize + (Math.random() * 8 - 4);

        // 获取不重叠的位置
        const position = this.findNonOverlappingPosition(
            { ...shuffled[i], size },
            this.visibleSlogans
        );

        const slogan = {
          ...shuffled[i],
          position,
          size,
          width: position.width
        };

        this.visibleSlogans.push(slogan);
      }
    },
    createHearts(count) {
      for (let i = 0; i < count; i++) {
        const heart = {
          style: {
            left: `${Math.random() * 100}vw`,
            top: `${Math.random() * 100}vh`,
            fontSize: `${10 + Math.random() * 30}px`,
            animationDuration: `${3 + Math.random() * 7}s`,
            animationDelay: `${Math.random() * 2}s`,
            opacity: 0.7 + Math.random() * 0.3
          }
        };
        this.hearts.push(heart);

        // 动画结束后移除爱心
        setTimeout(() => {
          this.hearts = this.hearts.filter(h => h !== heart);
        }, 10000);
      }
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Ma+Shan+Zheng&display=swap');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Ma Shan Zheng', cursive;
  background-color: #fff5f5;
  overflow-x: hidden;
  min-height: 100vh;
}

.app-container {
  position: relative;
  min-height: 100vh;
  width: 100vw;
  overflow: hidden;
}

.slogan-container {
  position: relative;
  min-height: 80vh;
  width: 100%;
  padding: 20px;
}

.slogan {
  position: absolute;
  font-weight: bold;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
  white-space: nowrap;
  transition: all 1s ease;
  z-index: 10;
  pointer-events: none;
  line-height: 1.3;
}

/* 标语淡入淡出动画 */
.slogan-fade-enter-active,
.slogan-fade-leave-active {
  transition: all 1.5s ease;
}

.slogan-fade-enter-from,
.slogan-fade-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

.heart {
  position: absolute;
  color: #ff6b6b;
  pointer-events: none;
  z-index: 1;
  animation: float 5s ease-in-out infinite;
  user-select: none;
}

@keyframes float {
  0% {
    transform: translateY(0) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: translateY(-100vh) rotate(360deg);
    opacity: 0;
  }
}

.footer {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  text-align: center;
  color: #888;
  font-size: 0.9rem;
  z-index: 10;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .slogan {
    white-space: normal;
    text-align: center;
    word-break: keep-all;
  }

  .slogan-container {
    min-height: 85vh;
    padding: 15px;
  }

  .footer {
    bottom: 10px;
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  .slogan {
    font-size: 18px !important;
    line-height: 1.5;
  }

  .slogan-container {
    padding: 10px;
  }
}
</style>